import { createBrowserHistory } from "history";
import React, { FunctionComponent, useEffect } from "react";
import WithGlobalLoader from "@Components/WithGlobalLoader";
import WithLocale from "@Components/WithLocale";
import { useScript } from "@Hooks/useScript";
import { NoRouteMatch, Redirect, Route, Router, RouteSwitch } from "@Lib/router";
import CartPage from "@Pages/CartPage";
import CustomizationEditPage from "@Pages/CustomizationEditPage";
import DraftsPage from "@Pages/DraftsPage";
import HomePage from "@Pages/HomePage";
import NotFoundPage from "@Pages/NotFoundPage";
import { gtmScript, kameleoonScripts } from "./externalScripts";

const history = createBrowserHistory();
const App: FunctionComponent = () => {
  // Usercentrics
  useScript(
    "https://app.usercentrics.eu/latest/main.js",
    false,
    true,
    process.env.REACT_APP_USERCENTRICS_API_KEY
  );

  // Kameleoon
  const kameleoonUrl = process.env.REACT_APP_KAMELEOON_API_KEY
    ? `//${process.env.REACT_APP_KAMELEOON_API_KEY}.kameleoon.eu/kameleoon.js`
    : undefined;
  useScript(kameleoonUrl, false, false);

  useEffect(() => {
    gtmScript();
    kameleoonScripts();
  }, []);

  return (
    <WithGlobalLoader initialLoading={true}>
      <WithLocale history={history}>
        <Router history={history}>
          <RouteSwitch>
            <Route component={HomePage} path="/" />
            <Route
              component={CustomizationEditPage}
              path="/:localizationSlug/customizations/:customizationId/edit"
            />
            <Route component={CartPage} path="/:localizationSlug/cart#/:step" />
            <Route
              component={Redirect}
              path="/:localizationSlug/cart"
              componentProps={{ href: `${history.location.pathname}#/checkout`, replace: true }}
              exact={true}
            />
            <Route component={DraftsPage} path="/:localizationSlug/dashboard/drafts" />
            <NoRouteMatch component={NotFoundPage} />
          </RouteSwitch>
        </Router>
      </WithLocale>
    </WithGlobalLoader>
  );
};

export default App;
